























































































































































































































import Vue from 'vue'
import { IDevice } from '@/types/model'
import easyapi from '@/easyapi'
import { dev_property_t } from '@/store/modules/pref'
import { DeviceType, VideoOutMode } from '@/types/api'
import AliveIndicator from '@/components/AliveIndicator.vue'
import DeviceTypeIcon from '@/components/DeviceTypeIcon.vue'
import HpdIcon from '@/components/HpdIcon.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import { whenWindowResized } from '@/utils'
import mixins from 'vue-typed-mixins'
import { masterDeviceDialogMixin, isDesktopMixin } from '@/mixins'

export default mixins(masterDeviceDialogMixin, isDesktopMixin).extend({
  components: {
    AliveIndicator,
    PreviewScreen,
    DeviceTypeIcon,
    HpdIcon,
  },
  data () {
    return {
      networkKeys: ['ip', 'netmask', 'multicastAddress'],
      previewScreenWidth: 0,
    }
  },
  computed: {
    mini (): boolean { return this.$vuetify.breakpoint.name === 'xs' },
    device (): IDevice | null { return this.dialog.device },
    deviceType (): DeviceType { return this.device ? this.device.deviceType : 'RX' },
    mac (): string { return this.device ? this.device.mac : '' },
    online (): boolean { return this.device ? this.device.connectionTime > 0 : false },
    canToggleLoopOut (): boolean { return !!this.device && this.device.deviceType === 'TX' && this.device.vendor === 'Aspeed' },
    canToggleAvOutput (): boolean { return !!this.device && !(this.device.deviceType === 'RX' && this.device.vendor === 'Aptovision') },
    canBlinkLed (): boolean { return !!this.device && this.online && this.device.vendor === 'Aspeed'},
    canResetToFactory (): boolean { return !!this.device && this.online && this.device.vendor === 'Aspeed' },
  },
  methods: {
    adjustScreenSize () {
      const el = this.$refs.previewRow
      if (el instanceof Element) {
        this.previewScreenWidth = el.clientWidth
      }
    },
    blinkLed (): void { if (this.device) { easyapi.blinkLed(this, this.device) } },
    toggleCec (): void { if (this.device) { easyapi.toggleCEC(this, this.device) } },
    toggleLoopOut (): void { if (this.device) { easyapi.toggleLoopOut(this, this.device) } },
    toggleAvOutput (): void { if (this.device) { easyapi.toggleAvOutput(this, this.device) } },
    openRenameDialog () { this.$router.push({ name: 'devlst_details_rename', params: { mac: this.mac } }) },
    openRebootDialog () { this.$router.push({ name: 'devlst_details_reboot', params: { mac: this.mac } }) },
    openResetDialog () { this.$router.push({ name: 'devlst_details_reset', params: { mac: this.mac } }) },
    openEdidDialog () { this.$router.push({ name: 'devlst_details_edid', params: { mac: this.mac } }) },
  },
  watch: {
    device (newVal) {
      if (!newVal) { return }
      Vue.nextTick(this.adjustScreenSize)
      // FIXME: Memory leak: remove this event listener when umount
      whenWindowResized(() => { // TODO: REFACTORING: use $state.common.windowSize
        this.adjustScreenSize()
        setTimeout(this.adjustScreenSize, 1000)
      })

    }
  },
  mounted () {
    //
  }
})
